module.exports = __webpack_public_path__ + "static/img/memberportal-step2.9402b028.svg";